// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o8-1";
export var stateContainer = "_o8-0";